
import { useState, useEffect } from 'react';
import { getAmbientGradientClass, getCurrentHour } from '../lib/ambientGradients';

export const useAmbientBackground = () => {
  const [currentHour, setCurrentHour] = useState(() => getCurrentHour());

  useEffect(() => {
  const updateHour = () => {
    const hour = getCurrentHour();
    console.log('Current hour detected:', hour);
    setCurrentHour(hour);
  };

    // Update immediately
    updateHour();

    // Set up interval to update every hour
    const now = new Date();
    const msUntilNextHour = (60 - now.getMinutes()) * 60 * 1000 - now.getSeconds() * 1000;
    
    // First timeout to sync with the hour
    const initialTimeout = setTimeout(() => {
      updateHour();
      
      // Then set up hourly interval
      const hourlyInterval = setInterval(updateHour, 60 * 60 * 1000);
      
      return () => clearInterval(hourlyInterval);
    }, msUntilNextHour);

    return () => clearTimeout(initialTimeout);
  }, []);

  const gradientClass = getAmbientGradientClass(currentHour);
  console.log('Generated gradient class:', gradientClass, 'for hour:', currentHour);
  
  return {
    gradientClass,
    currentHour
  };
};
